import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import image from '@/assets/landing/land-japanese.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingGenderButtons', 'LandingImage'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Lose weight and boost longevity with a Personal Japanese Diet Plan',
			size: 'large',
			customStyles: {
				textAlign: 'center',
				marginLeft: '1.25rem',
				marginRight: '1.25rem',
			},
		}),

		LandingGenderButtons: (): LandingComponentsConfig['LandingGenderButtons'] => ({
			femaleLabel: 'Diet for women',
			maleLabel: 'Diet for men',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: image,
			customStyles: {
				position: 'fixed',
				bottom: '25px',
				left: '0',
				right: '0',
				margin: '0',
			},
		}),
	},
}

export default schema
